import api from '../../../api';

export function getWabaList(pageNo, searchKey) {
    return api.get(`get-waba-message?pageNo=${pageNo}${searchKey ? `&searchKey=${searchKey}`: ``}`);
}

export function putWaba(id, payload) {
  return api.put(`update-waba-message/${id}`, payload);
}

export function postWaba(payload) {
  return api.post('create-waba-message', payload);
}
export function fireWaba(payload){
  return api.post('/test-template', payload);
}